import type { CSSProperties } from "react";
import {
  Home,
  ListTodo,
  Users,
  BriefcaseBusiness,
  CircleUserRound,
} from "lucide-react";
import { Link, useLocation } from "react-router";
import { useGetIdentity } from "ra-core";
import { effectiveRole, isFullAccessRole } from "../sales/roles";
import { workspaceNavigation, routeGroup } from "./workspaceNavigation";
const icons = {
  home: Home,
  tasks: ListTodo,
  counterparties: Users,
  management: BriefcaseBusiness,
  projects: BriefcaseBusiness,
  workspace: CircleUserRound,
};
export function MobileNavigation() {
  const { identity } = useGetIdentity();
  const role = effectiveRole(identity);
  const { pathname } = useLocation();
  const items = workspaceNavigation(role);
  const group = routeGroup(pathname);
  const active =
    group === "projects" && isFullAccessRole(role) ? "management" : group;
  return (
    <>
      <nav
        aria-label="Основная навигация"
        className="rovero-mobile-navigation"
        style={
          {
            "--nav-count": items.length,
            "--nav-index": Math.max(
              0,
              items.findIndex((i) => i.key === active),
            ),
          } as CSSProperties
        }
      >
        <div className="rovero-mobile-nav-track">
          <span className="rovero-mobile-nav-selection" aria-hidden="true" />
          {items.map((i) => {
            const Icon = icons[i.key as keyof typeof icons];
            return (
              <Link
                key={i.to}
                to={i.to}
                aria-current={active === i.key ? "page" : undefined}
                className="rovero-mobile-nav-item"
              >
                <Icon className="size-5 shrink-0" />
                <span className="rovero-mobile-nav-label">
                  {i.key === "projects"
                    ? "Проекты"
                    : i.key === "counterparties"
                      ? "Контакты"
                      : i.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
export function MobileHomeMenu() {
  return null;
}
